module.exports = __webpack_public_path__ + "img/aeroplane.9c06bd32.svg";